import { ApolloClient, NormalizedCacheObject } from '@apollo/client/core'

import { EntityWithUpload } from '@base/lib/imageUploads/EntityWithUpload'
import { fetchUploadFactory } from './fetchUploadFactory'

export async function handleGalleryUpload(
  files: { id: string; file: File | null }[],
  client: ApolloClient<NormalizedCacheObject>,
  entity: EntityWithUpload
): Promise<[string[], boolean]> {
  // Foreach file
  const filesToUpload = files.filter(
    (input) => !input.id && input.file !== null
  )
  try {
    const fetchUpload = fetchUploadFactory(entity)
    if (!fetchUpload) return [[], true]
    const uploadedFiles: string[] = []
    for (let i = 0; i < filesToUpload.length; i++) {
      const input = filesToUpload[i]
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const uploadDetails = await fetchUpload(input.file!, client)
      if (!uploadDetails) throw new Error('Fetch Upload Failed')
      const { url, fields } = uploadDetails
      let path: string | undefined
      const form = new FormData()
      fields.forEach(({ key, value }) => {
        if (key === 'key') path = value
        form.append(key, value)
      })
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      form.append('file', input.file!)
      if (!path) throw new Error('Unexpected Server Return')
      await fetch(url, {
        method: 'POST',
        mode: 'no-cors', // TODO remove in production
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        body: form
      })
      uploadedFiles.push(path)
    }

    let uploadIdx = 0
    const filePaths = files.map((input) => {
      if (input.id) return input.id
      else {
        return uploadedFiles[uploadIdx++]
      }
    })
    return [filePaths, false]
  } catch (e) {
    console.error(e)
    return [[], true]
  }
}
